import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    position: "relative",
    border: "1px solid #fff",
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  imgIco: {
    width: 30,
  },
  title: {
    fontSize: 25,
    color: "#000",
    marginTop: 15,
    maxWidth: "20ch",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  automaticDebitIcon: {
    width: 25,
  },
  IndicatorIcon: {
    width: 25,
    alignSelf: "center",
    display: "flex",
  },
  automaticDebitIconModal: {
    width: 16,
    marginRight: 5,
  },
  descriptionDebit: {
    fontSize: 14,
    margin: 0,
    color: "rgba(0, 0, 0, 0.54)",
  },
  descriptionDebitContent: {
    color: "#000",
    marginLeft: "3px",
  },
  descriptionSituation: {
    background: "#1874b9",
    color: "#fff",
    padding: "5px 20px",
    borderRadius: 20,
    fontSize: 14,
  },
  dialogContent: {
    [theme.breakpoints.down("sm")]: {
      padding: "8px 14px",
    },
  },
  dialogDisplayColumn: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    textAlign: "center",
  },
  warningDivNew: {
    width: "0px",
    height: "0",
    borderRight: "21px solid transparent",
    borderTop: "41px solid #E27725",
    background: "#E27725 0% 0% no-repeat padding-box",
    opacity: "1",
  },
  warningDiv: {
    top: "293px",
    left: "570px",
    width: "68px",
    height: "41px",
    background: "#E27725 0% 0% no-repeat padding-box",
    opacity: "1",
  },
  modalDescription: {
    padding: "0 45px",
  },
  modalTitle: {
    display: "flex",
    padding: "35px 0",
  },
  modalIcon: {
    textAlign: "center",
    margin: "0 auto",
  },
  modalItem: {
    display: "flex",
    alignItems: "center",
  },
  warningItem: {
    textAlign: "center",
    font: "Regular 18px / 22px Roboto",
    letterSpacing: "0",
    color: "#E27725",
    opacity: "1",
    paddingLeft: 10,
  },
  modalItemSpace: {
    justifyContent: "space-between",
  },
  modalTitleItem: {
    width: 170,
  },
  hrSize: {
    width: "50%",
    margin: "0 3px",
    [theme.breakpoints.down("sm")]: {
      width: "25%",
    },
  },
  hrSizeDebitAutomatic: {
    width: "40%",
    margin: "0 3px",
    [theme.breakpoints.down("sm")]: {
      width: "25%",
    },
  },
  modalContentItem: {
    width: 148,
    textAlign: "right",
  },
  linkToHome: {
    color: "#1874B9",
  },
}));

export default useStyles;
